__turbopack_context__.v({
  "allFilters": "Filter-module-scss-module__KpODSW__allFilters",
  "blink": "Filter-module-scss-module__KpODSW__blink",
  "buttonMobile": "Filter-module-scss-module__KpODSW__buttonMobile",
  "buttonMobileWith": "Filter-module-scss-module__KpODSW__buttonMobileWith",
  "buttons": "Filter-module-scss-module__KpODSW__buttons",
  "checkboxLabel": "Filter-module-scss-module__KpODSW__checkboxLabel",
  "checkmark": "Filter-module-scss-module__KpODSW__checkmark",
  "filterGroup": "Filter-module-scss-module__KpODSW__filterGroup",
  "filterHeader": "Filter-module-scss-module__KpODSW__filterHeader",
  "filterListPadding": "Filter-module-scss-module__KpODSW__filterListPadding",
  "filtering": "Filter-module-scss-module__KpODSW__filtering",
  "listGrid": "Filter-module-scss-module__KpODSW__listGrid",
});
